import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DialogService } from "src/app/Shared/dialog.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
// import { QuickLoanService } from "../services/quickLoan.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { LosService } from "src/app/_LOS/services/los.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import * as FileSaver from 'file-saver';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;
declare class Digio {
  constructor(options: DigioOptions);
  init(): void;
  submit(id1: string, id2: string, id3: string): void;
}

declare const digio: Digio;

interface DigioOptions {
  environment: string;
  Is_redirection_approach: boolean;
  theme: {
    primaryColor: string;
    secondaryColor: string;
    fontUrl: string;
    fontFormat: string;
    fontFamily: string;
  };
}
@Component({
  selector: "app-lms-bank-analysis",
  templateUrl: "./lms-bank-analysis.component.html",
  styleUrls: ["./lms-bank-analysis.component.scss"],
})
export class LmsBankAnalysisComponent implements OnInit {
  @Input() loanSummary: any;
  DocName: any = "";
  showSpinner: boolean = false;
  currentUser: any;
  Row: any;
  today: Date = new Date();
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  AllowExtension: any = constantUrl.AllowExtension;
  bankNameFoirCart: any = "other";
  fileNoFoirCart: any;
  productTypeFoirCart: any = "salariedLoan";
  passwordFoirCart: any;
  fileNameAttachment: any;
  dataSourceFoirCart: any;
  CustomerId: any = "";
  DocData: any;
  loading: boolean = false;
  ShowAnalytics_Data: boolean = false;
  BankAnalysisData: any;
  PriviousSixMonth: any = new Date();
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  PageAcess: any;
  lastUploadedFileName = "";
  CustomerList: any;
  displayedColumns: any[] = [];
  dataSource: any;
  @ViewChild(MatSort) sort: MatSort;
  dataUrl: any;
  docId: any;
  Vendor: any = { VendorName: "" };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  tableDateArr: any;
  loanDataForLoop: any;
  accountNumberDrodown: any;
  accountNumber: any = "";
  selectedAccountId: string = "";
  selectedAccountDetails: any = null;
  selectedAccountData: any;
  SelectedCustomer: any;
  MobileList: string[] = [];
  SelectedMobile: string = '';
  MSGType: string = 'Text';   // or WhatsApp
  ReceiveOn: string = '';

  constructor(
    private _Route: Router,
    private dialog: DialogService,
    private dataSharingService: DataSharingService,

    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private _EncrDecrService: EncrDecrService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Bank Analysis");
    console.log("loan Summary", this.loanSummary);

    let AllPage = JSON.parse(sessionStorage.getItem("AllPageAcess"));
    if (AllPage != null) {
      this.PageAcess = AllPage.filter((x) => x.Page_Name == "bank Analysis");

      if (
        this.PageAcess == "" ||
        this.PageAcess == null ||
        this.PageAcess == undefined
      ) {
        this.RedirectTo();
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Page Not Found",
        ...this.configSuccess,
      });
      this.dataSharingService.RefreshLoginPage.next("false");
      sessionStorage.removeItem("currentUser");
      sessionStorage.clear();
      this._Route.navigate(["Login"]);
    }

    this.getCustomerList();
    this.fileNoFoirCart = this.loanSummary.ApplicationNo;
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this._MasterService
      .Get_Sms_Configration({ Step_Name: "Bank Analysis Upload" })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.Vendor = res[0];
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        } else {
        }
      });
  }
  RedirectTo() {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: "You have not authorize to access this page ?",
      ...this.configSuccess,
    });
    this._Route.navigate([`lms-dashboard/lms-modifyBooking-list`]);
    return;
  }
  getCustomerList() {
    this.LmsService.GetCustomerByLoanNo({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((result) => {
      this.CustomerList = JSON.parse(JSON.stringify(result));
      // this.Product_Category = result[0].Product_Category;
      // this.DealerId = result[0].DealerId;
    });
  }

  fileChangeListenerFOIR(files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      delete this.DocData;
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      files.value = "";
      delete this.DocData;
      return;
    }

    let $this = this;
    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    this.DocName = _pre + "_" + sanitizedFileName;
    this.lastUploadedFileName = this.DocName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }

  clearFileAttachment() { }

  removeFileFoir(docFileInput: HTMLInputElement): void {
    this.DocName = "";

    docFileInput.value = "";
  }
  uploadDoc(data: any) {
    this.losService.UploadCrcDoc(data).subscribe((res: any) => {
      if (res == true) {
        var json = {
          password:
            this.passwordFoirCart == undefined ? "" : this.passwordFoirCart,
          bank: this.bankNameFoirCart == undefined ? "" : this.bankNameFoirCart,
          name: this.fileNoFoirCart == undefined ? "" : this.fileNoFoirCart,
          productType:
            this.productTypeFoirCart == undefined
              ? ""
              : this.productTypeFoirCart,
        };
        this._QuickLoanService
          .Save_BankStatementAnalysis({
            LoanId: Number(this.loanSummary.LoanId),
            CustomerId: Number(
              this.CustomerId == undefined ? 0 : this.CustomerId
            ),
            Request: JSON.stringify(json),
            DocName: this.DocName,
            LoginUserId: Number(this.currentUser.userId),
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
              this.passwordFoirCart = "";
              (this.CustomerId = ""), (this.DocName = "");
              this.bankNameFoirCart = "other";
              this.productTypeFoirCart = "salariedLoan";
            }
          });
      }
    });
  }
  onSubmitFoirCart() {
    this.uploadDoc({
      ApplicationNo: this.loanSummary.ApplicationNo,
      DocName: this.DocName,
      DocData: this.DocData,
    });
  }
  applyFilter(filterValue: string) {
    this.dataSourceFoirCart.filter = filterValue.trim().toLowerCase();
  }

  getQuickLoan_GetBankStatementAnalysis(id: any, result: any, view: any) {
    if (this.Vendor.VendorName == "CART") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "DocName",
        "View",
        "Delete",
      ];
    }
    if (this.Vendor.VendorName == "DIGIO") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Customer_Mobile",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "ViewStatement",
        "Delete",
      ];
    }
    this._QuickLoanService
      .QuickLoan_GetBankStatementAnalysis({
        LoanId: Number(this.loanSummary.LoanId),
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.BankAnalysisData = JSON.parse(JSON.stringify(res));
          if (id > 0) {
            var find = this.BankAnalysisData.find((x) => x.Id == id);
            if (find) {
              this.docId = find.DocId;
              this.blobToBase64Async(result, this.docId, view);
            }
          }

          this.dataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        } else {
          this.dataSource = null;
        }
      });
  }
  onSearchPendingStatus(row: any) {
    this._QuickLoanService
      .BankAnalysisUpload({
        LoanId: Number(this.loanSummary.LoanId),
        Request: row.Request,
        CustomerId: row.CustomerId,
        LoginUserId: this.currentUser.userId,
        ApplicationNo: row.Application_No,
        Id: row.Id,
        DocName: row.DocName,
        uploaddocUrl: this.docBaseUrl,
      })
      .subscribe((res: any) => {
        this.showSpinner = true;
        if (res.length > 0) {
          this.docId = res[0].MSG;
          this.showSpinner = false;
          this.Row = row;
          this.onDownloadWithoutView();
        }
      });
  }

  onDownloadWithoutView() {
    this.showSpinner = true;
    setTimeout(() => {
      this._QuickLoanService
        .DownloadAnalysisFile({
          DocId: this.docId,
        })
        .subscribe((res: any) => {
          if (res != null) {
            console.log("res", res);
            if (res.size == 0) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Please Try Again!!!",
                ...this.configSuccess,
              });

              this.showSpinner = false;
            } else {
              console.log("res", res);
              this.getQuickLoan_GetBankStatementAnalysis(
                this.Row.Id,
                res,
                false
              );
              // $("#DownloadModel").modal("hide");
              this.Row = null;
              this.docId = 0;
            }
          }
        });
    }, 30000);
  }

  blobToBase64Async(blob: Blob, filename, view): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      let $this = this;
      fileReader.onerror = (e) => reject(fileReader.error);

      fileReader.onload = function () {
        $this.dataUrl = fileReader.result.toString().split(";base64,").pop();
        $this.uploadData(filename + ".xlsx", view);
        return;
      };
      if (blob) {
        fileReader.readAsDataURL(blob);
      }
    });
  }
  uploadData(filename, view) {
    this.losService
      .UploadCrcDoc({
        DocName: filename,
        ApplicationNo: this.loanSummary.ApplicationNo,
        DocData: this.dataUrl,
      })
      .subscribe((res: any) => {
        if (view == true) {
          var url =
            this.docBaseUrl +
            this.loanSummary.ApplicationNo +
            this.Row.DocId +
            ".xlsx";
          window.open(url, "_blank");
        }
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Bank Statement Analysis Upload successfully!!!",
          ...this.configSuccess,
        });

        this.showSpinner = false;
      });
  }
  onDeleteBankStatement(row) {
    const payload: any = {
    Id: Number(row.Id),
    LoginUserId: this.currentUser.userId
  };
  if (this.Vendor?.VendorName === 'DIGIO') {
    payload.DocId = row.DocId;
  }
    this._QuickLoanService
      .QuickLoan_DeleteBankStatementAnalysis(payload)
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.showSpinner = false;
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      });
  }

  next() {
    let route = "";
    if (
      this.dataSource != undefined &&
      this.dataSource.filteredData.length != 0
    ) {
      this.LmsService.SaveNext_Loan({
        Loan_Id: this.loanSummary.LoanId,
        CommandName: "Bank Analysis",
        isStatus: 1,
      }).subscribe((response) => { });

      this.action.emit("next");
    }
  }
  onSubmit(response): void {
    const options = {
      environment: "sandbox",
      Is_redirection_approach: true,
      callback: function (res) {
        console.log("Response is: ", res);
        if (res.message != "Success") {
          $("#digio_doc_id").text(res.digio_doc_id);
          $("#RejectClick").click();
          //this._QuickLoanService
          //  .QuickLoan_DeleteBankStatementAnalysis({
          //    Id: 0,
          //    LoginUserId: this.currentUser.userId,
          //    DocId: res.digio_doc_id
          //  })
          //  .subscribe((res: any) => {
          //    if (res.length > 0) {
          //      this.snackBar.openFromComponent(SnackbarComponent, {
          //        data: res[0].MSG,
          //        ...this.configSuccess,
          //      });

          //      this.showSpinner = false;
          //      this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
          //    }
          //  });
        } else {
          $("#RefereshClick").click();
          // this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      },
      theme: {
        primaryColor: "#1F002A",
        secondaryColor: "#444444",
        fontUrl: "<font URL>", // replace with actual font URL
        fontFormat: "truetype",
        fontFamily: "NaviBody",
      },
    };

    var digio = new Digio(options);
    digio.init();
    var Ids = response.split(",");
    console.log("Ids", Ids);
    digio.submit(
      Ids[0].toString(), // consent request Id
      Ids[1].toString(), // customer Id
      Ids[2].toString() // gateway token id
    );
  }
  RejectData() {
    var digio_doc_id = $("#digio_doc_id").text();
    this._QuickLoanService
      .QuickLoan_DeleteBankStatementAnalysis({
        Id: 0,
        LoginUserId: this.currentUser.userId,
        DocId: digio_doc_id,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.showSpinner = false;
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      });
  }
  onSubmitDigioRequest() {
    var _find = this.dataSource?.filteredData.find(
      (x) => x.CustomerId == this.CustomerId && x.Status == "Pending"
    );
    if (_find) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "This customer Already Bank Analysis request Pending.",
        ...this.configSuccess,
      });
    } else {
      const NextFourtyDate = new Date();
      NextFourtyDate.setDate(NextFourtyDate.getDate() + 29);
      NextFourtyDate.setHours(0, 0, 0, 0);

      const CurrentDate = new Date();
      CurrentDate.setHours(0, 0, 0, 0);

      const PriviousSixMonthDate = new Date();

      // this.PriviousSixMonth.setDate(PriviousSixMonthDate.getMonth() - 6);
      // this.PriviousSixMonth.setHours(0, 0, 0, 0);
      this.PriviousSixMonth = new Date(PriviousSixMonthDate.setMonth(PriviousSixMonthDate.getMonth() - 12));

      const endDate =
        NextFourtyDate.toISOString().split("T")[0] + " 00:00:00.000";
      const startDate =
        CurrentDate.toISOString().split("T")[0] + " 00:00:00.000";
      const PriviousSixMonth =
        this.PriviousSixMonth.toISOString().split("T")[0] + " 00:00:00.000";
      var _findCustomer = this.CustomerList.find(
        (x) => x.CustomerId == this.CustomerId
      );

      if (
        _findCustomer.Customer_Email == undefined ||
        _findCustomer.Customer_Email == null ||
        _findCustomer.Customer_Email == ""
      ) {
        _findCustomer.Customer_Email == "";
      }
      //else {
      var json = {
        customer_details: {
          customer_name: _findCustomer.Customer,
          customer_email: _findCustomer.Customer_Email,
          customer_ref_id: this.loanSummary.ApplicationNo,
          customer_mobile: this.SelectedMobile,
          customer_identifier: this.SelectedMobile,
        },
        template_id: "",
        consent_details: {
          consent_start_date: startDate,
          consent_expiry_date: endDate,
          fi_start_date: PriviousSixMonth,
          fi_end_date: endDate,
        },
        customer_message: "Please verify your accounts via Account Aggregator",
        customer_notification_mode: this.getNotificationMode(),
        notify_customer: true

      };
      this._QuickLoanService
        .BankAnalysisRequestDigio({
          LoanId: Number(this.loanSummary.LoanId),
          CustomerId: Number(
            this.CustomerId == undefined ? 0 : this.CustomerId
          ),
          Request: JSON.stringify(json),
          LoginUserId: Number(this.currentUser.userId),
        })
        .subscribe((response: any) => {
          if (response.length > 0) {
            if (response[0].CODE == -1) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Request Send Customer For  Account Aggregator",
                ...this.configSuccess,
              });
              this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
              // this.onSubmit(response[0].MSG);
            }
            // this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
          }
        });
    }
    // }
  }
  onSearchViewStatement(row) {
    if (
      row.BankStatementDownloadData == null ||
      row.BankStatementDownloadData == undefined ||
      row.BankStatementDownloadData == ""
    ) {
      this._QuickLoanService
        .BankStatementDownloadDigio({ AggregatorId: row.AggregatorId })
        .subscribe((res: any) => {
          if (res.length > 0) {
            if (res[0].CODE == -1) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
            } else {
              row.BankStatementDownloadData = res[0].MSG;

              this.tableDateArr = JSON.parse(row.BankStatementDownloadData);

              this.loanDataForLoop = this.tableDateArr?.fi;
              console.log("loanDataForLoop", this.loanDataForLoop);

              this.accountNumberDrodown = this.loanDataForLoop.map((item) => ({
                account_id: item.account_id,
                account_number: item.account_number,
              }));
              console.log("accountNumberDrodown", this.accountNumberDrodown);
              this.onModel();
            }
          } else {
            console.log("Result---", row.BankStatementDownloadData);
          }
        });
    } else {
      // console.log("Result---", row.BankStatementDownloadData);

      this.tableDateArr = JSON.parse(row.BankStatementDownloadData);

      this.loanDataForLoop = this.tableDateArr?.fi;
      console.log("loanDataForLoop", this.loanDataForLoop);

      this.accountNumberDrodown = this.loanDataForLoop.map((item) => ({
        account_id: item.account_id,
        account_number: item.account_number,
      }));
      console.log("accountNumberDrodown", this.accountNumberDrodown);
      this.onModel();
    }
  }

  viewStatement() {
    // console.log("this.selectedAccountId on view click", this.selectedAccountId);
    this.selectedAccountData = this.loanDataForLoop.find(
      (data) => data.account_id == this.selectedAccountId
    );
    this._QuickLoanService
      .QuickLoan_GetLoanAnalytics_Data({ AccountId: this.selectedAccountId })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.ShowAnalytics_Data = true;
        } else {
          this.ShowAnalytics_Data = false;
        }
      })
    console.log("selectedAccountData", this.selectedAccountData);
  }


  onModel() {
    this.ShowAnalytics_Data = false;
    this.selectedAccountData = null;
    this.selectedAccountId = null;

    $("#modalOpen").modal("show");
    $("#modalOpen").css("z-index", "1050");
  }

  onCloseNPAStatementModel() {
    this.selectedAccountData = null;
    this.ShowAnalytics_Data = false;
    this.selectedAccountId = null;
    $("#modalOpen").modal("hide");
  }
  getShowAnalytics_Data() {
    this._QuickLoanService
      .BankAnalyticsDownloadDigio({
        AccountId: this.selectedAccountId
      })
      .subscribe((response: any) => {
        if (response != null) {
          FileSaver.saveAs(response, this.selectedAccountId + EXCEL_EXTENSION);
        }
      })


  }
  saveAs(blob: Blob, fileName: string) {
    const link = document.createElement("a");
    link.download = fileName;
    link.href = window.URL.createObjectURL(blob);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
  onCustomerChange(customerId: any) {
  this.SelectedCustomer = this.CustomerList.find(
    c => c.CustomerId == customerId
  );

  this.MobileList = [];
  this.SelectedMobile = '';

  if (this.SelectedCustomer) {
    if (this.SelectedCustomer.Customer_PhoneNo) this.MobileList.push(this.SelectedCustomer.Customer_PhoneNo);
    if (this.SelectedCustomer.Alternate_PhoneNo) this.MobileList.push(this.SelectedCustomer.Alternate_PhoneNo);
    if (this.SelectedCustomer.Customer_WhatsAppNo) this.MobileList.push(this.SelectedCustomer.Customer_WhatsAppNo);
  }
  if (this.MobileList.length === 1) {
      this.SelectedMobile = this.MobileList[0];
    }
}
private getNotificationMode(): string {
  switch (this.ReceiveOn) {
    case 'SMS':
      return 'SMS';
    case 'WHATSAPP':
      return 'WHATSAPP';
    case 'BOTH':
      return 'SMS_WHATSAPP';
    default:
      return 'SMS'; // safe fallback
  }
}
canDelete(row: any): boolean {
  if (!row || !row.CreatedOn) {
    return false;
  }

  // Optional: only for Pending requests
  if (row.Status !== 'Pending') {
    return false;
  }

  const createdOn = new Date(row.CreatedOn).getTime();
  const now = new Date().getTime();

  const diffInMinutes = (now - createdOn) / (1000 * 60);

  return diffInMinutes > 30;
}
}
